var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcursionIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.1,
    height: 95.683,
    viewBox: "0 0 99.1 95.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_43",
    "data-name": "Rect\\xE1ngulo 43",
    width: 99.1,
    height: 95.683,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_87",
    "data-name": "Trazado 87",
    d: "M0,88.237l30.737,7.446V38.829L0,31.377ZM48.247,0a17.589,17.589,0,0,0-17.61,17.591c0,7.414,11.123,28.1,17.61,39.217,6.488-11.114,17.61-31.8,17.61-39.217A17.587,17.587,0,0,0,48.247,0M34.965,17.591a13.286,13.286,0,1,1,26.566,0,13.283,13.283,0,0,1-26.566,0m33.4,70.646L99.1,95.683V38.829L68.366,31.377Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_88",
    "data-name": "Trazado 88",
    d: "M34.091,38.829V95.683l30.923-7.446V31.377l-1.168.359-15.6,32.357L35.478,38.47Z",
    fill: "#fdb54e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_89",
    "data-name": "Trazado 89",
    d: "M40.52,17.591a7.724,7.724,0,1,0,7.727-7.72,7.654,7.654,0,0,0-7.727,7.72",
    fill: "#fdb54e",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcursionIcon2);
export default __webpack_public_path__ + "static/media/excursionIcon2.5a50eef89b3bd2c6c3703122728f8ce2.svg";
export { ForwardRef as ReactComponent };